/** 学会服务 · 科学传播分类（与后台 summary / columnCode 对齐） */

export const SOCIETY_SCIENCE_TABS = [
  { key: 'work', label: '工作动态', columnCode: 'work', summary: '工作动态' },
  { key: 'journal', label: '期刊服务', columnCode: 'book', summary: '期刊服务' },
  { key: 'base', label: '科普基地', columnCode: 'base', summary: '科普基地' },
  { key: 'article', label: '科普文章', columnCode: 'article', summary: '科普文章' },
  { key: 'video', label: '科普视频', columnCode: 'video', summary: '科普视频' },
  { key: 'fossil', label: '化石保护', columnCode: 'fossil', summary: '化石保护' }
]

export const SCIENCE_COLUMN_LABEL = {
  work: '工作动态',
  book: '期刊服务',
  journal: '期刊服务',
  base: '科普基地',
  article: '科普文章',
  video: '科普视频',
  fossil: '化石保护'
}

/** 旧后台分类名 → 前台栏目 */
export const SCIENCE_CATEGORY_ALIASES = {
  学术专著: '期刊服务',
  科普读物: '期刊服务',
  科普活动: '工作动态'
}

const SCIENCE_TAB_LABELS = new Set(SOCIETY_SCIENCE_TABS.map(tab => tab.label))

export function canonicalScienceCategory(value) {
  const raw = String(value || '').trim()
  if (!raw) {
    return ''
  }
  return SCIENCE_CATEGORY_ALIASES[raw] || raw
}

function knownScienceLabel(value) {
  const label = canonicalScienceCategory(value)
  return SCIENCE_TAB_LABELS.has(label) ? label : ''
}

export function matchesScienceTab(item, tab) {
  if (!item || !tab) {
    return false
  }
  const label = tab.label
  if (knownScienceLabel(item.summary) === label) {
    return true
  }
  if (knownScienceLabel(item.category) === label) {
    return true
  }
  const code = String(item.columnCode || '').trim()
  if (code && (code === tab.columnCode || code === tab.key)) {
    return true
  }
  if (tab.key === 'journal' && (code === 'book' || code === 'journal')) {
    return true
  }
  return false
}

export function findScienceTabByEntry(item) {
  return SOCIETY_SCIENCE_TABS.find(tab => matchesScienceTab(item, tab)) || null
}

export function scienceColumnLabel(item) {
  const tab = findScienceTabByEntry(item)
  if (tab) {
    return tab.label
  }
  return SCIENCE_COLUMN_LABEL[item && item.columnCode] || knownScienceLabel(item && item.summary) || ''
}

/** 构建公开列表查询参数：由后端按科学传播栏目分页，前端仅做兼容性校验 */
export function buildScienceListParams(tab, pageNum, pageSize) {
  return {
    moduleCode: 'science',
    scope: 'society',
    columnCode: tab && tab.columnCode,
    pageNum,
    pageSize
  }
}

/** 详情页同栏 siblings */
export function scienceSiblingQuery(item) {
  return {
    moduleCode: 'science',
    scope: item && item.scope ? item.scope : 'society',
    pageNum: 1,
    pageSize: 200
  }
}

/** 首页科普基地 */
export const SCIENCE_BASE_SUMMARY = '科普基地'
